import * as React from 'react'
import { SVGProps } from 'react'

const SvgScarves = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path d="m19.077 15.129.923-.922-2.22-2.223-2.36-2.363 4.092-4.098-5.15-5.155H5.638L.487 5.523 4.58 9.621l-2.36 2.362L0 14.207l.923.922 1.76-1.762.202.203-1.76 1.763.922.922 1.76-1.762.202.203-1.76 1.763.923.922 1.76-1.762.202.203-1.76 1.763.922.921 1.76-1.761.202.203-1.76 1.763.923.921 2.22-2.223L10 15.047l2.358 2.362 2.221 2.223.923-.921-1.76-1.763.202-.203 1.76 1.761.922-.921-1.76-1.763.203-.203 1.76 1.762.922-.922-1.76-1.763.202-.203 1.76 1.762.922-.922-1.76-1.763.203-.203 1.76 1.762ZM17.67 5.523l-3.171 3.175-3.576-3.58 3.17-3.175 3.577 3.58Zm-5.15-3.851L10 4.195 7.48 1.672h5.04ZM7.18 16.025l-3.576-3.58 1.898-1.901 3.576 3.58-1.898 1.901Zm5.64 0L2.33 5.523l3.577-3.58 10.488 10.502-3.576 3.58Z" />
  </svg>
)

export default SvgScarves
